export default "__VITE_ASSET__8ccde513__"